import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import CityDistanceDrawer from "components/drawer/CityDistanceDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";

const CityDistanceTable = ({
  citydata,
  // hideDelete,
  hideEdit,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();

  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <CityDistanceDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {citydata?.slice(0).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="text-center text-xs">{index + 1}</TableCell>

            <TableCell className="text-center text-xs">
              {data.from_city_name}
            </TableCell>
            <TableCell className="text-center text-xs">
              {data.to_city_name}
              {/* {console.log(data.country_name)} */}
            </TableCell>
            <TableCell className="text-center text-xs">
              {data.distance} km
            </TableCell>
            <TableCell className="text-center text-xs">
              {data.duration}
              {/* {console.log(data.country_name)} */}
            </TableCell>
            {hideEdit && (
              <TableCell>
                <div className="flex justify-center">
                  <EditDeleteButton
                    id={data.id}
                    title={data.name}
                    handleUpdate={handleUpdate}
                    handleModalOpen={handleModalOpen}
                    hideEdit={hideEdit}
                    // hideDelete={hideDelete}
                  />
                </div>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default CityDistanceTable;
